/**************
 Cart
 ***************/

/* --- hh-forced-soldout: mini-cart helpers (BYRJAR) --- */
/**************
 HANDVIRKT "UPPSELT" — MINI-CART HLIÐIN (2026-09-10)
 ===================================================
 Skúffan hefur ENGA Liquid-teikningu: hver lína er byggð úr /cart.js hér að neðan.
 sections/theme-mini-cart.liquid sendir okkur því þáttaða stöðu úr snippetinu
 'hh-forced-soldout':

     window.HH_FORCED_SOLD_OUT = {
         hydration: ",mixed berries,",   // bragðnöfn á lágstöfum, kommu-vafin
         creatine:  "",                  // tómt = ekkert þvingað í þeim flokki
         energy:    "",
         kids:      "",
         skus:      ",HAP-1002,"         // hrái SKU-listinn úr metafieldinu
     };

 ÖRYGGISATRIÐI — FLOKKUR FYRST, BRAGÐ SVO
   "Mixed Berries" er til í þremur óskyldum vörum: Hydration Xpress (HAP-1002),
   Kreatín (HAP-2001) og Hydration KIDS (HAP-4002). Eigandinn bað AÐEINS um
   hydration-bragðið. Þess vegna finnum við FYRST flokk línunnar (handle/titill
   vörunnar, sama greining og snippetið notar) og berum bragðið svo EINGÖNGU saman
   við lista þess flokks. Kreatín- og KIDS-lína bera sig saman við tóman lista og
   eru aldrei snertar. ALDREI bera bragðnafn saman þvert á flokka.

 BILANAHEGÐUN: FAIL-OPEN
   Vanti blobbið, sé það rusl eða kasti eitthvað villu skila föllin false, hnappar
   haldast virkir og allt selst eins og venjulega. Villa í uppselt-rofanum má ALDREI
   stöðva sölu. Birgðastaða er hvergi snert.
 ***************/

const HH_SOLD_OUT_LABEL = "Uppselt";
const HH_SOLD_OUT_LINE_MSG = "Þetta bragð er uppselt — fjarlægðu vöruna til að geta klárað kaupin.";
const HH_SOLD_OUT_BLOCK_MSG = "Karfan inniheldur uppselda vöru. Smelltu á „Fjarlægja vöru“ á rauðmerktu línunni til að klára kaupin.";

// Heiti bragð-valkostsins eins og það birtist á vörunum (lágstafir).
const HH_FLAVOUR_OPTION_NAMES = ["bragð", "bragd", "flavor", "flavour", "energy xpress (bragð)"];

// Blobbið, eða null ef það vantar eða er rusl.
function hhForcedBlob() {
    try {
        const blob = window.HH_FORCED_SOLD_OUT;
        if (!blob || typeof blob !== "object") return null;
        return blob;
    } catch (e) {
        return null;
    }
}

// Flokkur línunnar. NÁKVÆMLEGA sama röð og greining og í hh-forced-soldout.liquid.
function hhCategoryOfLine(item) {
    const handle = String((item && item.handle) || "").toLowerCase();
    const title = String((item && item.product_title) || (item && item.title) || "").toLowerCase();
    if (handle.indexOf("creatine") !== -1 || title.indexOf("kreat") !== -1 || title.indexOf("creat") !== -1) return "creatine";
    if (handle.indexOf("energy") !== -1 || title.indexOf("energy") !== -1) return "energy";
    if (handle.indexOf("kids") !== -1 || title.indexOf("kids") !== -1) return "kids";
    return "hydration";
}

// Þvinguð bragðnöfn fyrir FLOKK þessarar línu (tómur listi = ekkert þvingað).
function hhForcedNamesForLine(item) {
    const blob = hhForcedBlob();
    if (!blob) return [];
    const raw = blob[hhCategoryOfLine(item)];
    if (typeof raw !== "string" || raw.length === 0) return [];
    return raw.split(",").map(function (name) {
        return name.trim().toLowerCase();
    }).filter(Boolean);
}

// Er ÞESSI karfulína þvinguð uppseld? Fail-open: allar villur skila false.
function hhIsForcedSoldOut(item) {
    try {
        if (!item) return false;
        const blob = hhForcedBlob();
        if (!blob) return false;

        // 1) Nákvæmt SKU. Grunnvörulínur bera HAP-xxxx og eru ótvíræðar.
        const skus = typeof blob.skus === "string" ? blob.skus : "";
        const sku = String(item.sku || "").trim().toUpperCase();
        if (sku && skus.indexOf("," + sku + ",") !== -1) return true;

        // 2) FLOKKUR FYRST — bragð er aðeins borið saman innan flokks línunnar.
        const names = hhForcedNamesForLine(item);
        if (names.length === 0) return false;

        // 2a) Bragð-valkostur línunnar (options_with_values): nákvæm samsvörun.
        const opts = Array.isArray(item.options_with_values) ? item.options_with_values : [];
        let sawFlavourOption = false;
        for (let i = 0; i < opts.length; i++) {
            const name = String((opts[i] && opts[i].name) || "").trim().toLowerCase();
            if (HH_FLAVOUR_OPTION_NAMES.indexOf(name) === -1) continue;
            sawFlavourOption = true;
            const value = String((opts[i] && opts[i].value) || "").trim().toLowerCase();
            if (names.indexOf(value) !== -1) return true;
        }
        // Varan HEFUR bragð-valkost og hann er ekki á listanum → selst áfram.
        if (sawFlavourOption) return false;

        // 2b) Enginn bragð-valkostur (t.d. búnt með aðeins "Magn" þar sem bragðið er í
        //     titlinum). Berum saman við valkosti og titla — ENN innan flokks línunnar.
        const values = [];
        if (Array.isArray(item.variant_options)) {
            for (let j = 0; j < item.variant_options.length; j++) {
                values.push(String(item.variant_options[j] || ""));
            }
        }
        const variantTitle = String(item.variant_title || "");
        if (variantTitle) values.push.apply(values, variantTitle.split("/"));
        for (let k = 0; k < values.length; k++) {
            if (names.indexOf(values[k].trim().toLowerCase()) !== -1) return true;
        }
        const haystack = (String(item.product_title || "") + " " + variantTitle).toLowerCase();
        for (let m = 0; m < names.length; m++) {
            if (names[m].length >= 4 && haystack.indexOf(names[m]) !== -1) return true;
        }
        return false;
    } catch (e) {
        return false; // FAIL-OPEN
    }
}

// Er einhver þvinguð lína í körfunni?
function hhCartHasForcedSoldOut(theCart) {
    try {
        const items = theCart && Array.isArray(theCart.items) ? theCart.items : [];
        for (let i = 0; i < items.length; i++) {
            if (hhIsForcedSoldOut(items[i])) return true;
        }
        return false;
    } catch (e) {
        return false; // FAIL-OPEN
    }
}

// Merki og skýring á þvingaðri línu.
function hhSoldOutBadgeHTML(forced) {
    if (!forced) return "";
    return `
                            <div class="hhSoldOutBadge" style="display:inline-block;margin:6px 0 2px;padding:3px 8px;border-radius:4px;background:#B3261E;color:#ffffff;font-family:Inter,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;">${HH_SOLD_OUT_LABEL}</div>
                            <div class="hhSoldOutLineNote" style="margin:2px 0 4px;font-family:Inter,sans-serif;font-size:12px;line-height:1.35;color:#B3261E;">${HH_SOLD_OUT_LINE_MSG}</div>`;
}

// Lítil áhersla þegar ýtt er á "+" á þvingaðri línu (engin CSS-skrá þarf).
function hhFlashSoldOutNotice(element) {
    try {
        const note = element && element.querySelector(".hhSoldOutLineNote");
        if (!note) return;
        note.style.transition = "none";
        note.style.opacity = "0.15";
        window.setTimeout(function () {
            note.style.transition = "opacity 0.25s ease";
            note.style.opacity = "1";
        }, 90);
    } catch (e) {
        /* engin vidbrogd eru betri en villa */
    }
}

// Læsir og aflæsir "Klára kaup" eftir innihaldi körfunnar. Fail-open í öllum villum.
function hhApplyCheckoutBlock(theCart) {
    let blocked = false;
    try {
        blocked = hhCartHasForcedSoldOut(theCart);
    } catch (e) {
        blocked = false;
    }
    try {
        const existing = document.querySelector("#hhSoldOutBlockNotice");
        if (existing) existing.remove();

        const button = document.querySelector("#miniCartFooterCheckout");
        if (!button) return;
        button.disabled = blocked;
        button.setAttribute("aria-disabled", blocked ? "true" : "false");
        button.style.opacity = blocked ? "0.45" : "";
        button.style.cursor = blocked ? "not-allowed" : "";
        if (!blocked) return;

        const footer = document.querySelector("#miniCartFooter");
        if (!footer) return;
        footer.insertAdjacentHTML(
            "afterbegin",
            `<div id="hhSoldOutBlockNotice" role="alert" style="margin:0 0 12px;padding:10px 14px;border:1px solid #B3261E;border-radius:8px;background:#FDECEA;color:#8C1D18;font-family:Inter,sans-serif;font-size:13px;line-height:1.4;">${HH_SOLD_OUT_BLOCK_MSG}</div>`
        );
    } catch (e) {
        /* FAIL-OPEN: ef eitthvad klikkar her ma hnappurinn standa eins og hann var */
    }
}
/* --- hh-forced-soldout: mini-cart helpers (ENDAR) --- */

// open cart
async function openCart(skipFetch = false, soft = false) {
    const repeatVariantMap = {
        // -------------
        // Lemon/Lime (20% discount)
        // -------------
        // 30 stikur
        44751437201546: "62eb1fee-b43c-4ab9-8f19-cb8f48c46824",
        // 60 stikur
        44751437234314: "8c1c58d3-e57c-4c1c-82d2-f346fc9ba3da",

        // -------------
        // Mixed Berries (20% discount)
        // -------------
        // 30 stikur
        44751437070474: "1f0b123d-a883-4185-9234-5ecca41b689d",
        // 60 stikur
        44751437103242: "92b7af8f-fb42-4106-b4f8-bb303c41d4a0",

        // -------------
        // Pina Colada (20% discount)
        // -------------
        // 30 stikur
        44751436939402: "834218bc-66c1-4e73-9616-fc34c4e5eb8d",
        // 60 stikur
        44751436972170: "52136089-cba5-4ebb-83fb-65724b9d099e",

        // -------------
        // Peach Crush (20% discount)
        // -------------
        // 30 stikur
        45773488357514: "f09c5484-0d6a-4956-bb6f-d645e1a28ffa",
        // 60 stikur
        45773488390282: "1c8adfc1-430e-4564-9fd2-72263912a038",

        // -------------
        // Peru (20% discount)
        // -------------
        // 30 stikur
        47230751506570: "748ca6b9-9d61-4d3d-9c59-d11520c3b91d",
        // 60 stikur
        47230751539338: "3f648f5a-cdb2-46af-8007-685689cbc5a7",

        // -------------
        // Strawberry Lemonade (20% discount)
        // -------------
        // 30 stikur
        50050860744842: "1192ae6e-6871-4296-9b81-d6987dd7e155",
        // 60 stikur
        50050860777610: "88e18fab-a57e-4b71-9356-1d057d4f5f30",

        // -------------
        // Energy Xpress - Epli & Kiwi (20% discount)
        // -------------
        // 30 stikur
        46556640477322: "1cdf7027-4789-4a98-8eb6-2970e5620cd0",
        // 60 stikur
        46556640510090: "00c254a4-3bab-44f1-8ebd-7cc5972ef82a"
    };

    const dlg = document.getElementById('miniCart');

    // open cart
    if (!dlg.open) dlg.show();
    
    // NO SCROLL not needed anymore
    // document.querySelector("body").classList.add("noScroll");

    // hide all sections
    if (!soft) {
    // hide all sections only on hard open
    ["#miniCartEmpty","#miniCartHeader","#miniCartProgressBody",
    "#miniCartBody","#miniCartUpsell","#miniCartFooter"]
        .forEach(sel => document.querySelector(sel).classList.remove("active"));

    // big overlay loader only on hard open
    document.querySelector("#miniCartContent").classList.add("loading");
    } else {
    // keep shell; only dim the items list
    const body = document.querySelector("#miniCartBody");
    body?.classList.add("loading");            // CSS spinner just for items
    body?.setAttribute("aria-busy","true");
    }

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    const repeatData = await buildRepeatUrl();
    const isRepeatCheckout = repeatData.isRepeatCheckout;

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach((item) => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading on the cart
    if (!soft) {
        document.querySelector("#miniCartContent").classList.remove("loading");
    } else {
        const body = document.querySelector("#miniCartBody");
        body?.classList.remove("loading");
        body?.removeAttribute("aria-busy");
    }

    //  update cart count in header nav
    const cartItemCount = cart.items.reduce((acc, item) => {
        acc = acc + item.quantity
        return acc;
    }, 0);

    document.querySelector("#headerIconsCart").setAttribute("data-count", cartItemCount);
    document.querySelector("#miniCartHeaderTitleCount").textContent = `(${cartItemCount})`;

    // HANDVIRKT UPPSELT: laesa "Klara kaup" ef thvingud lina er i korfunni.
    // Keyrt her (a undan tomu-korfu-utgongunni) svo stadan se alltaf rett uppfaerd.
    hhApplyCheckoutBlock(cart);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show main cart sections
    if (!soft) {
        document.querySelector("#miniCartHeader").classList.add("active");
        document.querySelector("#miniCartProgressBody").classList.add("active");
        document.querySelector("#miniCartBody").classList.add("active");
        document.querySelector("#miniCartUpsell").classList.add("active");
        document.querySelector("#miniCartFooter").classList.add("active");
    }

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach((item) => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Check if any 60+ stikur subscription item qualifies for free shipping
    let hasFreeShippingItem = false;
    cart.items.forEach((item) => {
        if (item.properties && item.properties._repeat_product) {
            const vt = (item.variant_title || item.title || '').toLowerCase();
            if (vt.includes('60 stikur') || vt.includes('90 stikur')) {
                hasFreeShippingItem = true;
            }
        }
        // Also check non-subscription 60+ stikur items via free_shipping metafield
        const vt2 = (item.variant_title || item.title || '').toLowerCase();
        if (vt2.includes('60 stikur') || vt2.includes('90 stikur')) {
            hasFreeShippingItem = true;
        }
    });

    // does this order contain a subscription (free shipping)
    if (cartSettings.enable_free_shipping_bar) {
        const miniCartHeaderBarInner = document.querySelector("#miniCartHeaderBarInner");
        const miniCartHeaderBarText = document.querySelector("#miniCartHeaderBarText");

        const qualifiesForFreeShipping = hasFreeShippingItem || cart.total_price >= cartSettings.free_shipping_threshold;

        miniCartHeaderBarInner.classList.toggle("active", qualifiesForFreeShipping);
        miniCartHeaderBarInner.style.width = qualifiesForFreeShipping
            ? '100%'
            : `${(cart.total_price / cartSettings.free_shipping_threshold) * 100}%`;

        if (qualifiesForFreeShipping) {
            miniCartHeaderBarText.innerHTML = `
                Til hamingju! Þú færð
                <div id="miniCartHeaderBarTextAmount"></div>
                FRÍA SENDINGU!
            `;
        } else {
            const remainingFreeShippingSpend = Math.max(0, cartSettings.free_shipping_threshold - cart.total_price);
            miniCartHeaderBarText.innerHTML = `
                Þig vantar
                <div id="miniCartHeaderBarTextAmount">${price(remainingFreeShippingSpend, true)}</div>
                fyrir fría heimsendingu
            `;
        }
    }

    // Update price — calculate repeat discount for subscription items
    let adjustedTotal = cart.total_price;
    cart.items.forEach((item) => {
        if (item.properties && item.properties._repeat_product) {
            // Subtract 20% of this item's price
            adjustedTotal -= Math.round(item.final_line_price * 0.20);
        }
    });

    if (isRepeatCheckout) {
        document.querySelector("#miniCartFooterTotal").innerHTML = `
                Heildarverð
                <span id="miniCartFooterTotalPrice">${price(
            adjustedTotal,
            true
        )}</span>
    `
        ;
    } else {
        document.querySelector("#miniCartFooterTotalPrice").textContent = price(
            cart.total_price,
            true
        );
    }

    // reset body container
    document
        .querySelectorAll(".miniCartBodyItem")
        .forEach((element) => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // HANDVIRKT UPPSELT: reiknad EINU SINNI per linu (flokkur fyrst, bragd svo).
        const hhForcedLine = hhIsForcedSoldOut(item);

        const hasProperties =
            item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // Check if key starts with an underscore
                if (key.startsWith("_")) {
                    continue;
                }

                // check for link
                if (
                    typeof item.properties[key] === "string" &&
                    item.properties[key].includes("https://")
                ) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null;
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice =
                    item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice =
                    variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, true)}</s>`;
            }

            /****************** actual price ******************/

            // If this is a Repeat subscription item, show discounted price
            const isRepeatItem = item.properties && item.properties._repeat_product;
            const displayPrice = isRepeatItem
                ? Math.round(item.final_line_price * 0.80)
                : item.final_line_price;

            // Show strikethrough of full price for repeat items
            if (isRepeatItem && !comparePrice) {
                HTML += `<s>${price(item.final_line_price, true)}</s> `;
            }

            HTML += price(displayPrice, true);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Sparaðu ${price(savings, true)})</span>`;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {
            // HANDVIRKT UPPSELT: aldrei bjoda askrift a uppseldu bragdi.
            if (hhForcedLine || !repeatVariantMap[item.variant_id] || Object.keys(item.properties).includes("_repeat_product")) {
                return ``;
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-id="${item.variant_id}" 
                >
                    Komdu í áskrift og sparaðu 20%
                    <svg width="82" height="60" viewBox="0 0 82 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M80.8284 32.8284C82.3905 31.2663 82.3905 28.7337 80.8284 27.1716L55.3726 1.71573C53.8105 0.153631 51.2778 0.153631 49.7157 1.71573C48.1536 3.27783 48.1536 5.81049 49.7157 7.37258L72.3431 30L49.7157 52.6274C48.1536 54.1895 48.1536 56.7222 49.7157 58.2843C51.2778 59.8464 53.8105 59.8464 55.3726 58.2843L80.8284 32.8284ZM0 30L0 34L78 34V30V26L0 26L0 30Z" fill="black"/>
                    </svg>
                </button>
            `;
        }

        // insert item
        const isRepeatItem = Object.keys(item.properties).includes(
            "_repeat_product"
        );

        document.querySelector("#miniCartBody").insertAdjacentHTML(
            "beforeend",
            `
            <div class="miniCartBodyItem${hhForcedLine ? " hhSoldOutLine" : ""}" key="${item.key}"${hhForcedLine ? ' data-hh-forced="1"' : ""}>
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.title}">

                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>${hhSoldOutBadgeHTML(hhForcedLine)}
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <div class="miniCartBodyItemPrice ${isRepeatItem ? "isRepeatItem" : ""}">${priceHTML()}</div>

                        ${
                            isRepeatItem
                                ? `<div class="miniCartBodyItemFlex">
                                        <div class="miniCartBodyItemRepeat">
                                            Áskrift
                                        </div>
                                        </div>
                                    `
                                : ""
                        }
                       
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg width="59" height="5" viewBox="0 0 59 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="2.5" x2="59.0085" y2="2.5" stroke="black" stroke-width="5"/>
                                </svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus"${hhForcedLine ? ' aria-disabled="true" title="Uppselt" style="opacity:0.35;cursor:not-allowed;"' : ""}>
                                <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="-0.00390625" y1="28" x2="59.0046" y2="28" stroke="black" stroke-width="5"/>
                                    <line x1="30.5" y1="59.0083" x2="30.5" y2="-0.000171661" stroke="black" stroke-width="5"/>
                                </svg>
                            </button>
                        </div>
                         <button class="miniCartBodyItemRemove">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                            <path d="M2.7041 4.375H15.1327" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.25781 4.375H13.5792V13.6964C13.5792 13.9711 13.4701 14.2346 13.2759 14.4288C13.0817 14.623 12.8182 14.7321 12.5435 14.7321H5.29353C5.01883 14.7321 4.7554 14.623 4.56116 14.4288C4.36694 14.2346 4.25781 13.9711 4.25781 13.6964V4.375Z" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6.3291 4.37521V3.85735C6.3291 3.17063 6.6019 2.51203 7.08748 2.02645C7.57307 1.54087 8.23167 1.26807 8.91839 1.26807C9.60511 1.26807 10.2637 1.54087 10.7493 2.02645C11.2349 2.51203 11.5077 3.17063 11.5077 3.85735V4.37521" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.36523 7.48389V11.6283" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10.4717 7.48389V11.6283" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Fjarlægja vöru
                        </button>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `
        );
    });

    // Show free glerbrúsi indicator for 60+ stikur subscriptions
    const existingBrusi = document.querySelector('.miniCartBrusiGift');
    if (existingBrusi) existingBrusi.remove();

    let has60plusSub = false;
    cart.items.forEach((item) => {
        if (item.properties && item.properties._repeat_product) {
            const vt = (item.variant_title || item.title || '').toLowerCase();
            if (vt.includes('60 stikur') || vt.includes('90 stikur')) {
                has60plusSub = true;
            }
        }
    });

    if (has60plusSub) {
        document.querySelector("#miniCartBody").insertAdjacentHTML(
            "beforeend",
            `<div class="miniCartBrusiGift" style="display:flex;align-items:center;gap:10px;padding:10px 16px;background:#F0FFF0;border-radius:8px;margin:8px 0;font-family:Inter,sans-serif;font-size:13px;font-weight:500;color:#333;">
                <span style="font-size:18px;">🎁</span>
                <span>Frír Glerbrúsi fylgir með áskriftinni þinni!</span>
            </div>`
        );
    }

    // Context-aware upsells: hide products already in cart
    const cartProductIds = new Set(cart.items.map(item => String(item.product_id)));
    document.querySelectorAll('.miniCartUpsellItem').forEach(function(upsell) {
        const upsellProductId = upsell.dataset.product;
        if (cartProductIds.has(upsellProductId)) {
            upsell.style.display = 'none';
        } else {
            upsell.style.display = '';
        }
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(
            element.querySelector(".miniCartBodyItemQuantityCount").textContent
        );

        // minus
        element
            .querySelector(".miniCartBodyItemQuantityMinus")
            .addEventListener("click", function () {
                if (quantity === 1) {
                    element.querySelector(".miniCartBodyItemRemove").click();
                } else {
                    quantity--;
                    updateCartItem();
                }
            });

        // plus
        element
            .querySelector(".miniCartBodyItemQuantityPlus")
            .addEventListener("click", function () {
                // HANDVIRKT UPPSELT: engin fjolgun a uppseldri linu.
                if (element.dataset.hhForced === "1") {
                    hhFlashSoldOutNotice(element);
                    return;
                }
                quantity++;
                updateCartItem();
            });

        // remove
        element
            .querySelector(".miniCartBodyItemRemove")
            .addEventListener("click", function () {
                quantity = 0;
                updateCartItem();

                // fade out and remove
                element.classList.add("fade");
                setTimeout(() => {
                    element.remove();
                }, 500);
            });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent =
                quantity;

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity,
            });

            // update active body
            await openCart(true, true);
        }

        // listen for upgrade button click
        element
            .querySelector(".miniCartBodyItemUpgrade")
            ?.addEventListener("click", async function () {
                const key = this.dataset.key;
                const variantID = parseInt(this.dataset.id);
                const sellingPlanID = parseInt(this.dataset.plan);

                // add loading animation
                this.classList.add("loading");

                // remove this product from the cart
                await changeCart({
                    id: key,
                    quantity: 0,
                });

                // add new product to cart (note, we don't change since we have a custom atc function)
                await addProduct({
                    items: [
                        {
                            quantity: 1,
                            id: variantID,
                            properties: {
                                "Tíðni": `1 MÁNAÐAR fresti`,
                                _repeat_interval_count: "1",
                                _repeat_interval_type: "MONTH",
                                _repeat_product: repeatVariantMap[variantID],
                            }
                        }
                    ],
                });

                await openCart(true, false);

                // remove loading animation
                this.classList.remove("loading");
            });
    });
}

// Listen for upsell option changes
document.querySelectorAll(".miniCartUpsellItem").forEach(function (element) {
    const select = element.querySelector(".miniCartUpsellItemWrapSelect");

    select?.addEventListener("change", function (e) {
        // get variant ID from dropdown selector
        const variantID = this.value;

        // set variant ID
        element.dataset.variant = variantID;
    });
});

// Add Upsell function
document
    .querySelectorAll(".miniCartUpsellItem")
    .forEach(function (element) {
        element.addEventListener("click", async function () {
            const button = element.querySelector("button");

            // add loading animation
            button.classList.add("loading");

            // create form data
            let formData = {
                items: [
                    {
                        quantity: 1,
                        id: this.dataset.variant,
                    },
                ],
            };

            // add product upsell
            await addProduct(formData);

            // remove loading animation
            button.classList.remove("loading");

            await openCart(false, false);
        });
    });

// listen for protection plan switch
document
    .querySelector("#miniCartFooterUpsellTopSwitchInput")
    ?.addEventListener("change", async function () {
        await openCart(true);
    });

// Upsell Swiper
const miniCartUpsellSwiper = new Swiper("#miniCartUpsellSwiper", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
    },
    navigation: {
        prevEl: "#miniCartUpsellSwiper .swiper-button-prev",
        nextEl: "#miniCartUpsellSwiper .swiper-button-next",
    }
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

// checkout button loading
document
    .querySelector("#miniCartFooterCheckout")
    .addEventListener("click", async function () {
        // HANDVIRKT UPPSELT: sidasta hlidid. Hnappurinn er thegar disabled, en ef
        // eitthvad kveikir a honum aftur stodvum vid her lika.
        if (hhCartHasForcedSoldOut(cart)) {
            hhApplyCheckoutBlock(cart);
            return;
        }

        this.classList.add("loading");

        // formdata
        let formData = {
            items: [],
        };

        // check if protection product is checked - if so atc
        if (
            document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked
        ) {
            // add protection product
            formData.items.push({
                quantity: 1,
                id: cartSettings.protection_upsell.variants[0].id,
            });
        }

        // add to cart
        if (formData.items.length > 0) {
            await addProduct(formData);
        }

        const repeatData = await buildRepeatUrl((cleanCart = true));
        if (repeatData.isRepeatCheckout) {
            const url = repeatData.repeatCheckoutUrl;

            this.classList.remove("loading");

            setTimeout(() => {
                window.location.href = url;
            }, 500);
        } else {
            // remove loading animation
            this.classList.remove("loading");
            // go to checkout
            window.location.href = `${Shopify.routes.root}checkout`;
        }
    });

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));
